import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Button, TextInput, TitleBar, View } from "../components/index.js";
import { getMonstersForpoints } from "../logic/createMonstersOprQuest.js";
import * as actions from "../redux/actions/actions.js";

const Play = ({ setStory }) => {
  const [threatLevelMax, setThreatLevelMax] = useState(750);
  const [monsters, setMonsters] = useState([]);

  useEffect(() => {
    // Optional: Handle potential initial data loading here if needed
    // (Consider using a separate data fetching hook or library)
  }, []);

  const getMonsters = async () => {
    const ret = getMonstersForpoints({ points: threatLevelMax });
    console.log(ret);
    setMonsters(ret);
  };

  return (
    <TitleBar marginLateral={15} showBack={false} titulo={"Play"}>
      <br></br>
      <View style={{ flexDirection: "row", maxHeight: "80px" }}>
        <TextInput title="Points" variant="outlined" value={threatLevelMax} onChange={setThreatLevelMax} />
        <Button style={{ maxWidth: "100px" }} onPress={getMonsters} text={"Carregar Monstros"} />
        <text>Points Left: {monsters.points_left} </text>
      </View>

      <View marginLateral={15} showBack={false} titulo={"Play"}>
        <style></style>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Points</th>
            </tr>
          </thead>
          <tbody>
            {monsters?.monsters &&
              monsters.monsters?.map((obj) => {
                return (
                  <tr>
                    <td>{obj.name}</td>
                    <td>{obj.points}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </View>
    </TitleBar>
  );
};

const mapStateToProps = (state) => ({
  user: state.Reducer.user,
  story: state.Reducer.story,
});

const mapDispatchToProps = (dispatch) => ({
  setStory: (story) => dispatch(actions.setStory(story)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Play);
